import datapoints from './datapoints';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import selectDefaultFolder from './selectDefaultFolder';
import selectNodeInFolderForest from './selectNodeInFolderForest';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import folderStore from 'owa-folders';
import { isFavoritingInProgress, lazyOnFavoritePersonaSelected } from 'owa-mail-favorites-store';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { addFrequentlyUsedFolder } from 'owa-mail-frequently-used-folders';
import { wasFolderPrefetched } from 'owa-mail-frequently-used-folders';
import { action } from 'satcheljs/lib/legacy';
/**
 * Select a persona node
 * @param personaId the folderId
 * @return a promise that resolves when the load persona table from server has completed
 */
export default action('selectPersona', datapoints.selectPersona)(function selectPersona(personaId) {
    var selectNodePromise;
    // Only perform the rest of selecting folder logic when
    // user navigates to a folder with the different folderId
    if (personaId != getSelectedNode().id) {
        var persona = getSharedFavoritesStore().favoritesPersonaNodes.get(personaId);
        if (!persona) {
            selectDefaultFolder();
            return Promise.resolve();
        }
        var isAddingInProgress = isFavoritingInProgress(persona.mainEmailAddress);
        var searchFolderNotFound = false;
        // If the search folder for this persona was not found and adding is not in progress, fallback to search
        // A new search folder will be generate further along this codepath
        if (!isAddingInProgress && !folderStore.folderTable.has(persona.searchFolderId)) {
            searchFolderNotFound = true;
            persona.searchFolderId = undefined;
            persona.isSearchFolderPopulated = false;
        }
        var willUseSearchFallback = !persona.isSearchFolderPopulated;
        var isPrefetchedFuf = persona.searchFolderId && wasFolderPrefetched(persona.searchFolderId);
        var selectPersonaDatapoint = returnTopExecutingActionDatapoint();
        // Datapoint is not present for unit tests
        if (selectPersonaDatapoint) {
            selectPersonaDatapoint.addCustomData({
                isSearchFallback: willUseSearchFallback,
                searchFolderNotFound: searchFolderNotFound,
                isPrefetchedFuf: !!isPrefetchedFuf,
            });
        }
        selectNodePromise = selectNodeInFolderForest(persona, 'FavoritesPersonaNode');
        lazyOnFavoritePersonaSelected.importAndExecute(persona.id);
        if (persona.searchFolderId) {
            addFrequentlyUsedFolder(persona.searchFolderId);
        }
    }
    // Called after selecting same/different persona
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode();
    return selectNodePromise;
});
//# sourceMappingURL=selectPersona.js.map